import { SB } from '@play-co/replicant';
import { airplaneTournamentSchema } from './tournament/airplane-tournament.schema';

export const airplaneMinigameDuration = -1; // Duration of the minigame in seconds. -1 means infinite.

export type AirplaneMinigameDifficulty = 'easy' | 'normal' | 'hard';

export const airplaneSchema = {
  airplane: SB.object({
    difficulty: SB.tuple(['easy', 'normal', 'hard']).default('normal'),

    // Remaining time in the minigame.
    remainingTime: SB.number().default(airplaneMinigameDuration),

    // Reward data.
    rewards: SB.object({
      points: SB.number().min(0),
      gems: SB.number().min(0),
      frenzyPoints: SB.number().min(0),
    }),

    // Current turn data.
    turn: SB.object({
      startTime: SB.number().min(0),
      seed: SB.string(),
    }).optional(),
  }).optional(),

  // Airplane tournament data.
  airplaneTournament: SB.object(airplaneTournamentSchema).optional(),
};
